"use client";

import { useBearStore } from "@money/frontend/store/store.ts";
import { type FC, type ReactNode, useCallback, useEffect } from "react";
import { useServerParams } from "@money/frontend/components/hooks/use.server.params.tsx";
import { useShallow } from "zustand/react/shallow";
import { useFetch } from "@money/frontend/components/hooks/use.fetch.tsx";

export const useUser = () => useBearStore((state) => state.user);

export const SetUser: FC<{ children: ReactNode }> = ({ children }) => {
  const { logged, setLogged } = useServerParams();
  const fetch = useFetch();

  const { user, setUser } = useBearStore(
    useShallow((state) => ({
      user: state.user,
      setUser: state.setUser,
    }))
  );

  const loginUser = useCallback(async () => {
    const luser = await fetch("/users/self", {
      cache: "no-cache",
    });
    if (luser.status === 401) {
      setUser(undefined);
      setLogged(false);
      return;
    }
    setUser(await luser.json());
  }, [logged, user]);

  useEffect(() => {
    if (!logged && user) {
      setUser(undefined);
    }

    if (logged && !user) {
      loginUser();
    }
  }, [logged, user]);

  if (logged && !user) {
    return null;
  }

  return <>{children}</>;
};
